import { Info } from '@mui/icons-material';
import { Alert, Grid } from '@mui/material';
import { FilterOperator, useGetGlobalFileListQuery } from '@kinetic-ui/data-layer';
import { getNodes } from 'kineticUtils/data';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ImageCardView from './ImageCardView';
import useImageUploadStyles from './styles';
import { ImageLibrarySelectProps } from './types';

const ImageLibrarySelect: React.FunctionComponent<ImageLibrarySelectProps> = (props) => {
  const classes = useImageUploadStyles();
  const { t } = useTranslation('common');
  const { files, setValue, multiple, sourceId } = props;
  const { data, loading } = useGetGlobalFileListQuery({
    variables: {
      limit: 1000,
      filterInput: [
        {
          value: sourceId,
          field: 'key',
          operator: FilterOperator.Equals,
        },
      ],
    },
  });
  const libraryImages = useMemo(() => {
    return getNodes(data?.getGlobalFiles)?.map((libraryImage) => {
      return {
        selected: files?.some((file) => file.id === libraryImage.id),
        ...libraryImage,
      };
    });
  }, [data?.getGlobalFiles, files]);

  return (
    <div className={classes.contentWrapper}>
      <div className={classes.listFiles}>
        {libraryImages?.length > 0 ? (
          <Grid sx={{ flexGrow: 1 }} container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {libraryImages.map((file, index) => {
                  return (
                    <Grid item key={index}>
                      <ImageCardView
                        file={file}
                        key={file.id}
                        loading={loading}
                        setPreviewImage={(image) => {
                          if (multiple) {
                            setValue([...(files ?? []), image]);
                          } else {
                            setValue([image]);
                          }
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <div className={classes.emptyContent}>
            <Alert severity='info' icon={<Info fontSize='small' />}>
              {t('emptyUploadedMessage')}
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
};
export default ImageLibrarySelect;
